import {Injectable, Injector} from '@angular/core';
import {HttpClient, HttpHeaders,HttpEvent,HttpInterceptor,HttpHandler,HttpRequest,HttpResponse} from "@angular/common/http";


import {Observable} from "rxjs/Observable";
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import {of } from 'rxjs/observable/of';
import { _throw as throwError } from "rxjs/observable/throw";
import {catchError, map, tap, timeout} from 'rxjs/operators';
import { mergeMap } from 'rxjs/operators';

import {MessageService} from "./message.service";
import {Survey} from "./survey/survey";
import {WeChatConfig} from "./wechatconfig";
import {Report} from "./report/report";
import {Router} from "@angular/router";
import { StoreService } from './store.service';
import {TokenService} from './tokenService.service';
declare var $:any;
// const hostUrl = 'http://leaftest3.chinaeast2.cloudapp.chinacloudapi.cn/';
// const hostUrl = 'http://localhost:4355/';
// const hostUrl = '/';
const hostUrl = window.location.href.indexOf('yyddi') !== -1 ? '/yyddi/' : './';


@Injectable()
// export class ApiService implements HttpInterceptor{
export class ApiService{
  private router: Router;
  private testEnvironment: any = [
    'localhost',
    'ttt.chinaeast2.cloudapp.chinacloudapi.cn',
    'leaftest3.chinaeast2.cloudapp.chinacloudapi.cn'
  ];
  private outOfSurveillance: any = [
    'sr/exposeoutapi/adderrormsg',
    'v1/configuration/',
    'v1/heartbeat/'
  ];
  private objUrl: string;


  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private storeService:StoreService,
    private tokenService: TokenService,
    injector: Injector) {
    setTimeout(() => this.router = injector.get(Router));
  }

  private headerObj = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
  //这里设置是作用于刷新时直接从localStorage里取token
  private httpOptions = {
    headers: new HttpHeaders(this.updateHeaders())
  }
  //这里暴露方法是为了在登录后手动从localStorage里取token
  setHeaders(){
    this.httpOptions = {
      headers: new HttpHeaders(this.updateHeaders())
    }
    console.log('httpOptions',this.httpOptions);
  }

  updateHeaders(): Record<string, any> {
    this.headerObj['transtalen-token'] = this.tokenService.findToken();
    this.headerObj['transtalenuserid'] = this.tokenService.findUserIdEncoder();
    return this.headerObj;
  }

  private versionUrl = hostUrl + 'assets/version.json';

  private charaterSurveyUrl = hostUrl + 'api/{1}/surveys';
  private answerQuestionUrl = hostUrl + 'sr/coursedna/surveys/{1}';//dna答题
  private updateSurveyUrl = hostUrl + 'api/surveys/{1}';
  private tickInitUrl = hostUrl + 'ddilearner/v1/user/tick/init';//倒计时初始化
  private tickUpdateSurveyUrl = hostUrl + 'ddilearner/v1/user/tick/update/{1}';//倒计时更新
  private tickResetUrl = hostUrl + 'ddilearner/v1/user/tick/reset';//倒计时重置
  private finishSurveyUrl = hostUrl + 'sr/coursedna/{1}/finishSurvey/{2}';//dna完成
  private resetDNASurveyUrl = hostUrl + 'sr/coursedna/surveys/{1}/reset';//dna重做
  private dnaReportUrl = hostUrl + 'sr/coursedna/surveys/{1}/report';//dna报告

  private resetSurveyUrl = hostUrl + 'api/surveys/{1}/reset';
  private reportUrl = hostUrl + 'api/surveys/{1}/report';

  private getCompanyListUrl = hostUrl + 'ddilearner/v1/user/companylist';//获取公司列表
  private createLearningPathUrl = hostUrl + 'ddilearner/v1/{1}/learningpathes';
  private updateLearningPathStatusUrl = hostUrl + 'api/learningpathes/{1}';

  private createPracticeUrl = hostUrl + 'api/{1}/practices';
  private getPracticeUrl = hostUrl + 'api/practices/{1}';
  private getPracticeByMetaIdUrl = hostUrl + 'api/{1}/practice';
  private practiceReportUrl = hostUrl + 'api/practices/{1}/report';
  private startNextCaseUrl = hostUrl + 'api/practices/{1}/startNextCase';
  private updatePracticeStatusUrl = hostUrl + 'api/practices/{1}';

  private answerQuizQuestionUrl = hostUrl + 'api/quizzes/{1}';
  private finishQuizUrl = hostUrl + 'api/quizzes/{1}/finish';
  private resetQuizUrl = hostUrl + 'api/quizzes/{1}/reset';
  private resetExerciseUrl = hostUrl + 'api/exercises/{1}/reset';

  private answerExerciseQuestionUrl = hostUrl + 'api/exercises/{1}';
  private finishExerciseUrl = hostUrl + 'sr/exercises/{1}/finish';

  private createCourseUrl = hostUrl + 'api/{1}/courses';
  private getCourseUrl = hostUrl + 'api/courses/{1}';
  private getCourseByMetaIdUrl = hostUrl + 'api/{1}/course';
  private finishLessonUrl = hostUrl + 'api/lessons/{1}/finish/{2}';

  private getGraduationUrl = hostUrl + 'api/graduation/{1}/{2}';

  private updateFeedbackPopedUrl = hostUrl + 'api/learningpathes/{1}/feedback';
  private addFeedbackUrl = hostUrl + 'api/feedbacks';

  private getHrReportsUrl = hostUrl + 'api/hrReports';
  private getCompanyReportUrl = hostUrl + 'api/companyReport';

  private checkRegisterUrl = hostUrl + 'api/checkRegister'
  private sendCodeUrl = hostUrl + 'ddilearner/v1/sms/send';
  private loginInPhoneOrAccountUrl = hostUrl + 'ddilearner/v1/user/login';
  private validateProtectionAccountUrl = hostUrl + 'ddilearner/v1/user/validateProtectionAccount';
  private updatePasswordUrl = hostUrl + 'ddilearner/v1/user/updatePassword';
  private getUserInfoUrl = hostUrl + 'ddilearner/v1/user/userinfo';
  private logoutUrl = hostUrl + 'ddilearner/v1/user/logout'

  private  applyUrl = hostUrl + 'api/apply';
  private  registerUserUrl = hostUrl + 'api/register';

  private wechatConfigUrl = hostUrl + 'api/jsapi';

  private getUserStatusAskingDurationUrl = hostUrl + 'ddilearner/v1/user/loginstatus/interval'
  private getLearningPathMetaIdByPathIdUrl = hostUrl + 'ddilearner/v1/getLearningPathMetaId/{1}'
  exerciseId = 0;
  //获取影响力进度
  getProgress (exerciseId:number):Observable<any>{
    return this.http.get<any>(hostUrl+`sr/exercise/getExerciseProgress/${exerciseId}`,this.httpOptions)
    .pipe(catchError(this.handleError('getReport', null))
      );
  }
  //存储影响力进度
  saveProgress(data:any):Observable<any>{
    return this.http.post<any>(hostUrl+"sr/exercise/saveExerciseProgress",data,this.httpOptions)
    .pipe(catchError(this.handleError('getReport', null))
      );
  }
  //存储时间
  learingTime(data:any):Observable<any>{
    return this.http.post<any>(hostUrl+"ddilearner/v1/user/event/click",data,this.httpOptions)
    .pipe(catchError(this.handleError('getReport', null))
      );
  }

  getCustomizeMetaInfo (): Observable<any> {
    return this.http.get<any>(hostUrl+"sr/customized/getCompanyLogo", this.httpOptions)
      .pipe(catchError(this.handleError('getCompanyLogo', null))
      );
  }
  getCompanyList (): Observable<any> {
    return this.http.get<any>(this.getCompanyListUrl, this.httpOptions)
      .pipe(catchError(this.handleError('getReport', null))
      );
  }
  getWechatConfig (data: any): Observable<WeChatConfig> {
    return this.http.post<WeChatConfig>(this.wechatConfigUrl, data, this.httpOptions)
      .pipe(catchError(this.handleError('getWechatConfig', null))
      );
  }

  getOrCreateSurvey (surveyMetaId: string, learningPathId: string, learningTourId: string): Observable<Survey> {
    return this.http.post<Survey>(this.charaterSurveyUrl.replace("{1}", surveyMetaId), {learningPathId: learningPathId, learningTourId: learningTourId}, this.httpOptions)
      .pipe(catchError(this.handleError('getOrCreateSurvey', null))
      );
  }

  answerQuestion (surveyId: string, questionId: number, optionId: number): Observable<any> {
    return this.http.post<any>(this.answerQuestionUrl.replace("{1}", surveyId), {questionId: questionId, optionId: optionId}, this.httpOptions)
      .pipe(catchError(this.handleError('answerQuestion', null))
      );
  }

  resetDNASurvey (surveyId: string): Observable<any> {
    return this.http.post<any>(this.resetDNASurveyUrl.replace("{1}", surveyId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('resetSurvey', null))
      );
  }

  resetSurvey (surveyId: string): Observable<any> {
    return this.http.put<any>(this.resetSurveyUrl.replace("{1}", surveyId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('resetSurvey', null))
      );
  }

  tickInit (tickInitType: string): Observable<any> {
    return this.http.post<any>(this.tickInitUrl + '/' + tickInitType,{type: tickInitType}, this.httpOptions)
      .pipe(catchError(this.handleError('tickInit', null))
      );
  }

  tickReset (tickInitType: string): Observable<any> {
    return this.http.post<any>(this.tickResetUrl + '/' + tickInitType,{type: tickInitType}, this.httpOptions)
      .pipe(catchError(this.handleError('tickInit', null))
      );
  }

  tickUpdateSurveyTime (surveyId: string): Observable<any> {
    return this.http.post<any>(this.tickUpdateSurveyUrl.replace("{1}", surveyId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('tickUpdate', null))
      );
  }

  updateUsedTime (surveyId: string, usedTime: number): Observable<any> {
    return this.http.put<any>(this.updateSurveyUrl.replace("{1}", surveyId), {usedTime: usedTime}, this.httpOptions)
      .pipe(catchError(this.handleError('updateUsedTime', null))
      );
  }

  finishSurvey (surveyId: string,type: string): Observable<any> {
    return this.http.post<any>(this.finishSurveyUrl.replace("{1}", surveyId).replace("{2}", type), {}, this.httpOptions)
      .pipe(catchError(this.handleError('finishSurvey', null))
      );
  }

  getDNAReport (surveyId: string): Observable<any> {
    return this.http.get<any>(this.dnaReportUrl.replace("{1}", surveyId), this.httpOptions)
      .pipe(catchError(this.handleError('getReport', null))
      );
  }

  getReport (surveyId: string): Observable<any> {
    return this.http.get<any>(this.reportUrl.replace("{1}", surveyId), this.httpOptions)
      .pipe(catchError(this.handleError('getReport', null))
      );
  }

  getOrCreateLearningPath (learningPathMetaId: string): Observable<any> {
    return this.http.post<any>(this.createLearningPathUrl.replace("{1}", learningPathMetaId), {},this.httpOptions)
      .pipe(catchError(this.handleError('getOrCreateLearningPath', null))
      );
  }

  updateLearningPathStatus (learningPathId: string): Observable<any> {
    return this.http.put<any>(this.updateLearningPathStatusUrl.replace("{1}", learningPathId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('updateLearningPathStatusUrl', null))
      );
  }

  createPractice (learningPathId: string): Observable<any> {
    return this.http.post<any>(this.createPracticeUrl.replace("{1}", learningPathId), {},this.httpOptions)
      .pipe(catchError(this.handleError('createPractice', null))
      );
  }
  getLearningPathMetaIdByPathId(learningPathId: string): Observable<any> {
    return this.http.get<any>(this.getLearningPathMetaIdByPathIdUrl.replace("{1}", learningPathId), this.httpOptions)
      .pipe(catchError(this.handleError('getPractice', null))
      );
  }
  getPractice (practiceId: string): Observable<any> {
    return this.http.get<any>(this.getPracticeUrl.replace("{1}", practiceId), this.httpOptions)
      .pipe(catchError(this.handleError('getPractice', null))
      );
  }

  getPracticeByMetaId (practiceMetaId: string): Observable<any> {
    return this.http.post<any>(this.getPracticeByMetaIdUrl.replace("{1}", practiceMetaId), {},this.httpOptions)
      .pipe(catchError(this.handleError('getPracticeByMetaId', null))
      );
  }

  updatePracticeStatus (practiceId: string): Observable<any> {
    return this.http.put<any>(this.updatePracticeStatusUrl.replace("{1}", practiceId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('updatePracticeStatus', null))
      );
  }

  getPracticeReport (practiceId: string): Observable<any> {
    return this.http.get<any>(this.practiceReportUrl.replace("{1}", practiceId), this.httpOptions)
      .pipe(catchError(this.handleError('getPracticeReport', null))
      );
  }

  startNextCase (practiceId: string): Observable<any> {
    return this.http.patch<any>(this.startNextCaseUrl.replace("{1}", practiceId), this.httpOptions)
      .pipe(catchError(this.handleError('startNextCase', null))
      );
  }

  resetQuiz (quizId: string): Observable<any> {
    return this.http.put<any>(this.resetQuizUrl.replace("{1}", quizId),{}, this.httpOptions)
      .pipe(catchError(this.handleError('resetQuiz', null))
      );
  }

  resetExercise (exerciseId: string): Observable<any> {
    return this.http.put<any>(this.resetExerciseUrl.replace("{1}", exerciseId),{}, this.httpOptions)
      .pipe(catchError(this.handleError('resetExercise', null))
      );
  }

  answerQuizQuestion (quizId: string, questionId: number, optionId: number): Observable<any> {
    return this.http.patch<any>(this.answerQuizQuestionUrl.replace("{1}", quizId), {questionId: questionId, optionId: optionId}, this.httpOptions)
      .pipe(catchError(this.handleError('answerQuestion', null))
      );
  }

  answerExerciseQuestion (exerciseId: string, questionId: number, optionId: number): Observable<any> {
    return this.http.post<any>(this.answerExerciseQuestionUrl.replace("{1}", exerciseId), {questionId: questionId, optionId: optionId}, this.httpOptions)
      .pipe(catchError(this.handleError('answerQuestion', null))
      );
  }

  finishQuiz (quizId: string): Observable<any> {
    return this.http.put<any>(this.finishQuizUrl.replace("{1}", quizId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('answerQuestion', null))
      );
  }

  finishExercise (exerciseId: string): Observable<any> {
    return this.http.put<any>(this.finishExerciseUrl.replace("{1}", exerciseId), {}, this.httpOptions)
      .pipe(catchError(this.handleError('answerQuestion', null))
      );
  }

  createCourse (learningPathId: string): Observable<any> {
    return this.http.post<any>(this.createCourseUrl.replace("{1}", learningPathId), {},this.httpOptions)
      .pipe(catchError(this.handleError('createCourse', null))
      );
  }

  getCourse (courseId: string): Observable<any> {
    return this.http.get<any>(this.getCourseUrl.replace("{1}", courseId), this.httpOptions)
      .pipe(catchError(this.handleError('getCourse', null))
      );
  }

  getCourseByMetaId (courseMetaId: string): Observable<any> {
    return this.http.post<any>(this.getCourseByMetaIdUrl.replace("{1}", courseMetaId),{}, this.httpOptions)
      .pipe(catchError(this.handleError('getCourseByMetaId', null))
      );
  }

  finishLesson (lessonId: string, externalId: string): Observable<any> {
    return this.http.put<any>(this.finishLessonUrl.replace("{1}", lessonId).replace("{2}", externalId), {}, this.httpOptions);
    // .pipe(catchError(this.handleError('finishLesson', null))
    // );
  }

  getGraduationByLearningPathId (learningPathId: string, userId: string): Observable<any> {
    return this.http.get<any>(this.getGraduationUrl.replace("{1}", learningPathId).replace("{2}", userId), this.httpOptions)
      .pipe(catchError(this.handleError('getGraduationByLearningPathId', null))
      );
  }

  updateFeedbackPoped (learningPathId: string): Observable<any> {
    return this.http.put<any>(this.updateFeedbackPopedUrl.replace("{1}", learningPathId),{}, this.httpOptions)
      .pipe(catchError(this.handleError('updateFeedbackPoped', null))
      );
  }

  addFeedback (level: number, comment: string): Observable<any> {
    return this.http.post<any>(this.addFeedbackUrl, {level: level, comment: comment}, this.httpOptions)
      .pipe(catchError(this.handleError('addFeedback', null))
      );
  }

  getHrReports (): Observable<any> {
    return this.http.get<any>(this.getHrReportsUrl, this.httpOptions)
      .pipe(catchError(this.handleError('getHrReports', null))
      );
  }

  getCompanyReport (): Observable<any> {
    return this.http.get<any>(this.getCompanyReportUrl, this.httpOptions)
      .pipe(catchError(this.handleError('getCompanyReport', null))
      );
  }

  checkRegister (): Observable<any> {
    return this.http.get<any>(this.checkRegisterUrl, this.httpOptions)
      .pipe(catchError(this.handleError('sendCode', null))
      );
  }

  sendCode (data: any): Observable<any> {
    return this.http.post<any>(this.sendCodeUrl, data, this.httpOptions)
      .pipe(catchError(this.handleError('sendCode', null))
      );
  }
  loginInPhoneOrAccount(data: any, requestOptions?: { withToken?: boolean }): Observable<any> {
    const withToken = !requestOptions || requestOptions.withToken !== false;
    const httpOptions = withToken
      ? this.httpOptions
      : {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          })
        };
    return this.http.post<any>(this.loginInPhoneOrAccountUrl, data, httpOptions)
      .pipe(
        tap((res) => {
          if (res) {
            this.storeService.notification.notAuthed.next(null);
          }
        }),
        catchError(this.handleError('loginInPhoneOrAccount', null))
      );
  }
  validateProtectionAccount(data: any): Observable<any> {
    return this.http.post<any>(this.validateProtectionAccountUrl, data, this.httpOptions)
      .pipe(catchError(this.handleError('validateProtectionAccount', null))
      );
  }
  updatePassword(data: any): Observable<any> {
    return this.http.post<any>(this.updatePasswordUrl, data, this.httpOptions)
      .pipe(catchError(this.handleError('updatePassword', null))
      );
  }
  getUserInfo():Observable<any> {
    return this.http.get<any>(this.getUserInfoUrl, this.httpOptions)
      .pipe(catchError(this.handleError('loginInPhoneOrAccount', null))
      );
  }
  logout():Observable<any> {
    return this.http.get<any>(this.logoutUrl, this.httpOptions)
      .pipe(catchError(this.handleError('logout', null))
      );
  }
  getUserStatusAskingDuration():Observable<any> {
    return this.http.get<any>(this.getUserStatusAskingDurationUrl, this.httpOptions)
      .pipe(catchError(this.handleError('userStatysAskingDuration', null))
      );
  }

  onApply (): Observable<any> {
    return this.http.get<any>(this.applyUrl, this.httpOptions)
      .pipe(catchError(this.handleError('onApply', null))
      );
  }

  registerUser (data: any): Observable<any> {
    return this.http.post<any>(this.registerUserUrl, data, this.httpOptions)
      .pipe(catchError(this.handleError('registerUser', null))
      );
  }

  //项目列表接口和项目学习进度接口
  getProjectProgress(projectId){
    return this.http.get<any>(hostUrl + 'ddilearner/v2/user/learning/projectProgress?needDetails=true&projectIds=' + projectId , this.httpOptions)
    .pipe(catchError(this.handleError('getProjectProgress', null))
    );
  }

  //项目列表接口和项目学习进度接口
  getSingleProjectProgress(){
    return this.http.get<any>(hostUrl + 'ddilearner/v2/user/learning/projectProgress?needDetails=false', this.httpOptions)
    .pipe(catchError(this.handleError('getSingleProjectProgress', null))
    );
  }

  getKasInfo (exerciseId: number,practiceId : number): Observable<any> {
    this.exerciseId = exerciseId;
    console.log(this.exerciseId)
    return this.http.get<any>(hostUrl+`sr/resolvingConflicts/reports/${exerciseId}/${practiceId}`, this.httpOptions)
    .pipe(catchError(this.handleError('getKasInfo', null))
    );
  }

  getKasInfos (exerciseId: number,practiceId : number): Observable<any> {
    this.exerciseId = exerciseId;
    console.log(this.exerciseId)
    return this.http.get<any>(hostUrl+`api/practices/${exerciseId}/${practiceId}/report`, this.httpOptions)
    .pipe(catchError(this.handleError('getKasInfos', null))
    );
  }

  getReportKas(exerciseId: number,practiceId : number): Observable<any> {
    this.exerciseId = exerciseId;
    console.log(this.exerciseId)
    return this.http.get<any>(hostUrl+`sr/practice/getReports/${exerciseId}/${practiceId}`, this.httpOptions)
    .pipe(catchError(this.handleError('getReportKas', null))
    );
  }

  getNewReportKas(practiceId : number): Observable<any> {
    return this.http.get<any>(hostUrl+`wx/api/report/${practiceId}`, this.httpOptions)
    .pipe(catchError(this.handleError('getNewReportKas', null))
    );
  }

  getmultiKas(multiExerciseMetaId : number): Observable<any> {
    return this.http.get<any>(hostUrl+`api/multiFinish/${multiExerciseMetaId}`, this.httpOptions)
    .pipe(catchError(this.handleError('getmultiKas', null))
    );
  }

  //获取当前项目下课程分类
  getProjectSort(projectId : number): Observable<any> {
    return this.http.get<any>(hostUrl+`ddilearner/v3/project/category?projectId=${projectId}`, this.httpOptions)
      .pipe(catchError(this.handleError('getProjectSort', null))
      );
  }

  //获取项目下的课程分类详细数据
  getProjectSortList(projectId : number,type:number): Observable<any> {
    return this.http.get<any>(hostUrl+`ddilearner/v2/user/learning/projectProgress?needDetails=true&projectIds=${projectId}&type=${type}`, this.httpOptions)
      .pipe(catchError(this.handleError('getProjectSortList', null))
      );
  }

  //查询用户学习进度
  getUserQueryLearningProgress(learningPathMetaId : number){
    return this.http.get<any>(hostUrl+`ddilearner/v2/user/learning/progress?learningPathMetaIds=${learningPathMetaId}`, this.httpOptions)
    .pipe(catchError(this.handleError('getUserQueryLearningProgress', null))
    );
  }

  getLevelInfo (reports : any) {
    let that = this;
    $.ajax({
      url: hostUrl+"sr/insideapi/getlevel",
      type: "post",
      dataType: "json",
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(this.getKaList(reports)),
      async: false,
      headers : {
        'transtalen-token' : this.tokenService.findToken(),
        'transtalenuserid' : this.tokenService.findUserIdEncoder()
      },
      success:function (){},
      error:function (err){
        if(err.status === 401 && Number(err.responseJSON.code) === 106){
          that.storeService.notification.notAuthed.next(true);
        }
      }
    });
  }

  private getKaList(report) {
    let kaJson = {
      id: report.id,
      name: report.name,
      type: report.type,
      kas: {},
      exercisesId: this.exerciseId,
      questionId: null,
      optionId: null,
    };
    if (window["exercises" + this.exerciseId] != null) {
      let exerciseConfig = window["exercises" + this.exerciseId];
      kaJson.questionId = exerciseConfig.questionId;
      kaJson.optionId = exerciseConfig.optionId;
    }

    if (report) {
      for (let i = 0; i < report.kas.length; i++) {
        let kaItem = report.kas[i];
        if (kaItem) {
          //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
          kaJson.kas[kaItem.name] = kaItem.value;
        }
      }
    }
    return kaJson;
  }

  //获取版本信息
  getVersionData(): Observable<any> {
    let headers = this.updateHeaders();
    headers['Accept'] = '*/*';
    let httpOptions = {
      headers: new HttpHeaders(headers)
    };
    console.log('httpOptions',httpOptions);
    return this.http.get<any>(this.versionUrl, httpOptions).pipe(catchError(this.handleError('getVersionData', null)));
  }

  ajax(object): Observable<any>{
    this.objUrl = object.url;
    if(object.url.indexOf("http://") == 0 || object.url.indexOf("https://") == 0 ){
      this.objUrl  = object.url;
    }else{
      //删除接口衔接处多余的斜杠
      const hostUrlHasSlashEnd = hostUrl[hostUrl.length - 1] === '/'
      const objectUrlHasSlashHead = object.url[0] === '/'
      let rewriteHostUrl = ""

      if(hostUrlHasSlashEnd && objectUrlHasSlashHead){
        this.objUrl  = hostUrl.slice(0,hostUrl.length - 1) + object.url;
      }else{
        this.objUrl  = hostUrl + object.url;
      }
    }
    let type = object.type? object.type.toLowerCase(): 'get';
    let data = object.data? object.data: {};
    if( type == 'get'){
      return this.http.get<any>( this.objUrl ,this.httpOptions)
        .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
    }else if( type == 'post'){
      return this.http.post<any>( this.objUrl , data, this.httpOptions)
      .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
    }else if( type == 'patch'){
      return this.http.patch<any>( this.objUrl , data, this.httpOptions)
        .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
    }else if( type == 'put'){
      return this.http.put<any>( this.objUrl , data, this.httpOptions)
        .pipe(timeout(15000), catchError(this.handleError('ajax', null)));
    }
  }

  loadConfig(url:any):Observable<any>{
    return this.http.get<any>(url,this.httpOptions)
      .pipe(catchError(this.handleError('ajax',null)));
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // error reporting to server side is done in app-error-handler
      var postData = {
        errorMsg:JSON.stringify(error)
      }
      $.ajax({
        url: hostUrl + "sr/exposeoutapi/adderrormsg",
        type: "POST",
        contentType:'application/json;charset=utf-8',
        data: JSON.stringify(postData),
        dataType: "JSON",
        headers : {
          'transtalen-token' : this.tokenService.findToken(),
          'transtalenuserid' : this.tokenService.findUserIdEncoder()
        },
        success: function (data) {
          if(data.success){
            //alert("错误信息已经发送,不要重复提交");
          }
        }
      });

      // if(this.testEnvironment.indexOf(window.location.hostname) === -1) {
      //   this.outOfSurveillance.indexOf(this.objUrl) === -1 ?  this.inSurveillanceFun(error) : this.outOfSurveillanceFun(error);
      // }else{
      //   this.outOfSurveillanceFun(error);
      // }

      this.inSurveillanceFun(error);
      //错误处理
      this.responseErrHandler(error);
      // Let the app keep running by returning an empty result.
      return throwError(error);//将错误继续传递到页面
      // return of(result as T);
    };
  }

  // 监控内
  inSurveillanceFun(error){
    if(error.status === 403){
      this.router.navigate(['new-login']);
    }
    // if (error.status === 401) {
    //   // const domain = window.location.hostname;
    //   // const referUrl = encodeURIComponent(window.location.href);
    //   // window.location.href = '/api/login?domain=' + domain + '&referUrl=' + referUrl;
    //   this.storeService.notification.notAuthed.next(true);
    // }else if(error.status === 404){
    //   this.router.navigate(['error','404']);
    // }else if(error.status === 500&& error.url.indexOf('/api/jsapi')===-1){
    //   console.log("test error.url="+error.url);
    //   console.log("test error: = "+(error.url.indexOf('/api/jsapi')===-1));
    //   //this.router.navigate(['error','500']);
    // } else{
    //   this.router.navigate(['error','500']);
    // }
  }

    // 监控外
  outOfSurveillanceFun(error){
      if(error.status === 401){
        //未授权,登录状态改为false
        this.storeService.notification.notAuthed.next(true);
      }
  }

  //全局错误处理器
  responseErrHandler(error){
    // console.log('响应错误---',error)
    if(error.status === 401){
      const url = (error.url || '') + '';
      if (url.indexOf('/v1/user/login') > -1) {
        return;
      }
      this.storeService.notification.notAuthed.next(true);
    }else{
      console.log('message:'+ JSON.stringify(error));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/api.service.ts